import React from 'react';
import DefaultRoutes from '../../routing/defaultRoutes/DefaultRoutes';
import { ContentTypes } from '../../core/constants/contentTypes';

function HotKeysWrapper() {
  return (
    <div className='cpt-hot-keys-wrapper'>
      <DefaultRoutes contentType={ContentTypes.HotKeysContent} />
    </div>
  );
}
export default HotKeysWrapper;
